//$(document).ready(function(){
   theme = {
     init : function(){
       theme.singleProduct();
       theme.navProduct();
       theme.accountModal();
       theme.blogLoadmore();
       theme.removeProduct();
       theme.collapseIcon();
       theme.productViewType();
       theme.featured();
       theme.bannerHigh();
       theme.filterCollection();
       theme.textCircle();
       theme.toggleMenu();
       theme.stickyHeader();
       theme.cartUpsell($);
       },
     singleProduct : function(){
       if(typeof product_name != typeof undefined){
         theme.actionProduct(product_name,true);
       }
     },
    actionProduct : function(product_name,push){
        var single_product = $(document).find('.main-content-product');
        var data = [];
        $.ajax({
            type : "GET",
            url :window.location.protocol+'/products/'+product_name+'.json',
            async : false,
            success : function(response){
                data = response.product;
            }
        });
        var variants = data.variants;
        var select = $('.single-option-variant');
      	var select2 = $('.special-dropdown');
        select.on('change',function () {
            theme.selectVariant(single_product, variants,push);
        });
        select2.on('change',function () {
              theme.selectVariant(single_product, variants,push);

              option = $(this).val();

              for (var i in variants) {
                 variant = variants[i];

                if (variant.id == option) {              	
                  var price = variant.price;
                  //console.log(price);
                  $('.price-sale').text('$'+price);
                }



              }



          });
    },
    selectVariant : function(single_product,variants,push){
   
        var option = [];
        var variant = [];
        var select = $('.single-option-variant');
        select.each(function () {
            option.push($(this).val());
        })
        option = option.join(',').toLowerCase().replace(/[^A-Z0-9]+/ig, "");
        for (var i in variants) {
            var vri = [variants[i].option1,variants[i].option2,variants[i].option3].join(',').toLowerCase().replace(/[^A-Z0-9]+/ig, "");
            if (vri === option) {
                variant = variants[i];
                theme.handleSelectVariant(single_product,variant,push);
                break;
            }
        }
    },
    handleSelectVariant : function(container,variant,state){
        if(variant) {
          debugger;
          
            var variant_id = $(container).find('[name="id"]');
            var price = $(container).find('.price-text');
            //var wish = $(container).find('.add-wishlist');
            //$(wish).attr('data-variant', variant.id);
            $(variant_id).val(variant.id);
            if(state == true){
                window.history.pushState({}, '', '?variant=' + variant.id);
            }
            if (parseFloat(variant.compare_at_price) > parseFloat(variant.price)) {
                $(price).find('.price-sale').html(money_format + (variant.price));
                $(price).find('.no-sale').html(money_format + (variant.compare_at_price) ).show();
                //var price = parseFloat(variant.price)*100;
                //var compare_price = parseFloat(variant.compare_at_price);
                //var p = price/compare_price;
                //$('.sale-rate').html('Discount '+(100 - p)+'%').show();
            } else {
                $(price).find('.price-sale').html(money_format + (variant.price));
                $(price).find('.no-sale').hide();
                //$('.sale-rate').hide();
            }
            if (variant.image_id != null) {
                var id = variant.image_id;
                $(container).find('[data-id="'+id+'"]').trigger('click');
            }
            //theme.wishlist(container, variant.id);
        }
    },
    wishlist : function(main,variant_id){
        if(typeof customer_id != typeof undefined){
            var wished = true;
            if(wishlists.indexOf(variant_id.toString()) < 0){
                wished = false;
            }
            if(wished){
                $(main).find('.add-wishlist i').removeClass('fa-heart-o').addClass('fa-heart');
            }else{
                $(main).find('.add-wishlist i').addClass('fa-heart-o').removeClass('fa-heart');
            }
        }
    },
     navProduct : function(){
       $('.big-image').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: false,
          asNavFor: '.nav-image',
            fade: true,
          adaptiveHeight: true
        });
     
       $('.nav-image').slick({
         slidesToShow: 5,
         slidesToScroll: 1,
         asNavFor: '.big-image',
         infinite:false,
         focusOnSelect:true,
         arrows:false,
         responsive: [
           {
             breakpoint: 1024,
             settings:{
               slidesToShow:4
             }
           },
           {
             breakpoint: 600,
             settings:{
               slidesToShow:4
             }
           },
           {
             breakpoint: 480,
             settings:{
               slidesToShow:3
             }
           }
         ]
       });
        
       
        
     },
       accountModal : function(){
           $('.login-link').on('click',function(e){
               e.preventDefault();
               $('.login-form').toggleClass('active');
               $('.register-form').removeClass('active');
           })
           $('.register-link').on('click',function(e){
               e.preventDefault();
               $('.register-form').toggleClass('active');
               $('.login-form').removeClass('active');
           })
           $('.close-modal-login').on('click',function(e){
               e.preventDefault();
               $('.login-form').removeClass('active');
           })
           $('.close-modal-register').on('click',function(e){
               e.preventDefault();
               $('.register-form').removeClass('active');
           })
           $('.custom-form-container').on('click',function(){
               $('.register-form').removeClass('active');
               $('.login-form').removeClass('active');
           })
       },
       blogLoadmore : function(){
           var blogLoadmore = $('.list-article');
           blogLoadmore.imagesLoaded(function(){
               blogLoadmore.isotope();
           })
           $('.blog-3-columns .groups').on('click','li',function(e){
               e.preventDefault();
               var active = $(this).find('a').data('filter');
               $(this).siblings('li').removeClass('active');
               $(this).addClass('active');
               blogLoadmore.isotope({filter:active});
           });
           $('.blog-masonry .tab-pane').imagesLoaded(function(){
               $('.blog-masonry .tab-pane').isotope();
           })
           $('.show-more').on('click','a',function(e){
               e.preventDefault();
               var url = $(this).attr('href');
               $.ajax({
                   method:"GET",
                   url:url,
                   error : function(response){

                   },
                   success : function(response){
                       var response = $(response);
                       var articles = response.find('.list-article').html();
                       var load = response.find('.show-more').html();
                       blogLoadmore.append(articles).data('isotope',false);
                       blogLoadmore.imagesLoaded(function(){
                           blogLoadmore.isotope({'filter':'*'});
                       })
                       $('.show-more').html(load);
                   }
               })
           });
       },
       removeProduct : function(){
           $('.product-remove').find('.remove').on('click',function(e){
               var remove = confirm("Are you sure want to delete this item !");
               if(!remove){
                   e.preventDefault();
               }
           })
       },
       collapseIcon : function(){
           $(document).find(".panel-collapse").on("hide.bs.collapse", function(e){
               $(this).parents('.widget').find(".collapse-icon").html('<i class="fa fa-angle-right"></i>');
           }).on("show.bs.collapse", function(e){
               $(this).parents('.widget').find(".collapse-icon").html('<i class="fa fa-angle-down"></i>');
           });
       },
       productViewType : function(){
           var type = getCookie('_view_type');
           $('.product-view-type').removeClass('active');
           if(type != false){
               $('.product-view').removeClass('grid-product').addClass(type);
               $('[data-type="'+type+'"]').addClass('active');
           }else{
               $('.product-view').addClass('grid-product');
               $('[data-type="grid-product"]').addClass('active');
           }
           $(document).on('click','.product-view-type',function(e){
               e.preventDefault();
               var type = $(this).data('type');
               $(this).siblings('.product-view-type').removeClass('active');
               $(this).addClass('active');
               if(type == 'list-product'){
                   $('.product-view').addClass(type).removeClass('grid-product');
                }else{
                   $('.product-view').addClass(type).removeClass('list-product');
               }
               setCookie('_view_type',type,60);
           })
       },
       featured : function(){
           $('#featured').find('.in').each(function(){
               var id = $(this).attr('id');
               $('[href="#'+id+'"]').find('.status').removeClass('fa-plus').addClass('fa-minus');
               $('[href="#'+id+'"]').addClass('active');
           })
           $('.open-panel').on('click',function(){
               if(!$(this).hasClass('active')){
                   $(this).addClass('active');
                   $(this).find('.status').removeClass('fa-plus').addClass('fa-minus');
                   $(this).parents('.panel').siblings('.panel').each(function(){
                       $(this).find('.open-panel').removeClass('active');
                       $(this).find('.status').removeClass('fa-minus').addClass('fa-plus')
                   })
               }else{
                   $(this).removeClass('active');
                   $(this).find('.status').addClass('fa-plus').removeClass('fa-minus');
               }
           })
       },
       bannerHigh : function(){
           theme.setHeight();
           $(window).on('resize',function(){
               theme.setHeight();
           })
       },
       setHeight : function(){
           if($('.top-banner').length > 0) {
               var h = parseInt($('.top-banner').css('height').replace('px', '')) + parseInt($('.bottom-banner').css('height').replace('px', '')) + 30;
               $('.right-banner').css('height', h + 'px');
           }
           if($('.banner-4-container').length > 0) {
               var hbn = parseInt($('.banner-4-container').find('.list-banner').css('height').replace('px', ''));
               $('.banner-4-container').find('.big-banner').css('height', hbn + 'px');
           }
           if($('.register-form').length > 0){
               var hf = $('.register-form .background.right').css('height');
               $('.register-form .background.left').css('height',hf);
           }
       },
       filterCollection : function(){
           theme.activeFilter();
           var isotopePBC = $('.isotope-pbc');
           isotopePBC.imagesLoaded(function(){
               isotopePBC.isotope({filter:'.all'});
           });
           $('.filter-item').on('click',function(){
               $(this).siblings('li').removeClass('active');
               $(this).addClass('active');
               theme.activeFilter();
               var filter = $(this).data('filter')
               isotopePBC.isotope({filter:filter});
           })

       },
       activeFilter : function(){
           if($('.pbc-container').length > 0){
               var p = $('.filter-item.active').position();
               var w = $('.filter-item.active').css('width');
               $('.show-active').css({'width':w,'left':p.left+'px'});
           }
       },
       textCircle : function(){
           var $example1	= $('.circle_text').hide();
           $example1.show().arctext({radius: 300});
       },
       toggleMenu : function(){
           $('.toggle-menu').on('click',function(e){
               e.preventDefault();
             //   CD CODE
               $('.header .menu-responsive .links').addClass('active');
               $('.second_level').removeClass('active');
               if($('.header .menu-responsive').hasClass('show_menus')){
                 $(this).find('i').addClass('fa-bars').removeClass('fa-remove');
                 $('.header .menu-responsive').removeClass('show_menus');
                 $('.header .menu-responsive .links').removeClass('active');
               }else{
                 $(this).find('i').removeClass('fa-bars').addClass('fa-remove');
                 $('.header .menu-responsive').addClass('show_menus');
               }
           })
       },
       stickyHeader : function(){
         // CD CODE
         var anno_height = $('#shopify-section-announcement-bar').height();
         var header_height = $('#shopify-section-header').height() + anno_height;
         var topbar_height = $('.header .top-bar-menu').height();
         
         if ($(window).width() < 767) {
           $('#shopify-section-header').css('top', anno_height);
           $('body').css('padding-top', anno_height);
           
           $(window).on('scroll',function(){
             var o = window.pageYOffset;
             if(o >= anno_height - 25){
               $('.header .top-bar-menu').addClass('hide');
               $('#shopify-section-header').addClass('fixed-menu');
             }else{
               $('.header .top-bar-menu').removeClass('hide');
               $('#shopify-section-header').removeClass('fixed-menu');
             }
           });
         }
         else
         {
           $('#shopify-section-announcement-bar').addClass('fixed-menu');
           $('body').css('padding-top', anno_height);

           $(window).on('scroll',function(){
             var o = window.pageYOffset;
             if(o >= anno_height){
               $('body').css('padding-top', header_height);
               $('#shopify-section-header').addClass('fixed-menu');
               $('#shopify-section-header').css('top', anno_height - topbar_height);
             }else{
               $('body').css('padding-top', anno_height);
               $('#shopify-section-header').removeClass('fixed-menu')
               $('#shopify-section-header').css('top', '0');
             }
           });
         }
         
//          var anno_height = $('#shopify-section-announcement-bar').height();
//          var header_height = $('#shopify-section-header .main-menu').height() + anno_height;
//          var topbar_height = $('.header .top-bar-menu').height();
         
//          if ($(window).width() < 767) {
//            $('#shopify-section-header').css('top', anno_height);
//            $('body').css('padding-top', anno_height);
//          }
//          else
//          {
//            $('#shopify-section-announcement-bar').addClass('fixed-menu');
//            $('body').css('padding-top', anno_height);

//            $(window).on('scroll',function(){
//              var o = window.pageYOffset;
//              if(o >= anno_height){
//                $('body').css('padding-top', header_height);
//                $('#shopify-section-header .main-menu').addClass('fixed-menu');
//              }else{
//                $('body').css('padding-top', anno_height);
//                $('#shopify-section-header .main-menu').removeClass('fixed-menu');
//              }
//            });
//          }
           
       },
     
     
     cartUpsell : function( o ) {
       o(document).on("click", ".usic__stick-btn", function () {
         var s = o(this);
         s.prop("disabled", !0);
         var e = s.parents(".usic__stick"),
             t = e.attr("data-product-data");
         o.ajax({
           url: "/cart/add",
           type: "post",
           dataType: "html",
           data: t,
           success: function (t) {
             var i = o(t).find(".shop_table > tbody");
             o(".shop_table.cart > tbody").html(i.html());
             var a = o(t).find(".cart-subtotal");
             o(".cart-subtotal").html(a.html()),
               s.text("Added to cart"),
               e.addClass("usic__upsell-added"),
               o.ajax({
               url: "/cart",
               type: "post",
               dataType: "html",
               success: function (t) {}
             });
           }
         });
       });
     }
   }
   theme.init();
//});
SlideShow = {
    init : function(){
        $('.slide-show').each(function(){
            var id = $(this).data('id');
            SlideShow.build(id);
        })
    },
    build : function(id){
        var slide_show = $('#slide-show-'+id);
        var options = slide_show.data('options');
        slide_show.owlCarousel({
            nav:options.nav,
            navText:['<i class="fa fa-chevron-left"></i>','<i class="fa fa-chevron-right"></i>'],
            loop:options.loop,
            autoplay:options.autoplay,
            autoplayTimeout:options.autoplayTimeout,
            margin:0,
            responsive:{
                0:{
                    items:1
                },
                768:{
                    items:1
                },
                992:{
                    items:1
                },
                1200:{
                    items:1
                }
            }
        })
        SlideShow.reSize();
    },
    reSize : function() {

        SlideShow.handlesize();
        $(window).on('resize', function () {
            SlideShow.handlesize();
        });
    },
    handlesize : function(){
        var owlSlide = $('.slide-show-container')[0];
        var top = $(owlSlide).position().top;
        var wh = window.innerHeight;
        $(owlSlide).find('.content-slide').css('height',(wh-top)+'px');
    }
}
SlideShow.init();
MyStaff = {
    init : function(){
        $('.my-staff-slick').each(function(){
            var id = $(this).data('id');
            MyStaff.build(id);
        });
    },
    build : function(id){
        var slide = $('#my-staff-slick-'+id);
        slide.slick({
            slidesToShow: 3,
            arrows:false,
            dots:true,
            infinite:true,
            variableWidth: true,
            slidesToScroll: 2,
            responsive: [
                {
                    breakpoint: 1199,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        slidesToShow: 3,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 991,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        slidesToShow: 3,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        slidesToShow: 2,
                        variableWidth: false,
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        arrows: false,
                        centerMode: false,
                        slidesToShow: 1,
                        variableWidth: false,
                        slidesToScroll: 1
                    }
                }
            ]
        });
        if(window.innerWidth > 1200){
            MyStaff.width(slide);
        }
        $(window).on('resize',function(){
            if(window.innerWidth > 1200){
                MyStaff.width(slide);
            }
        })
        slide.on('swipe', function(event, slick, direction){
            if(window.innerWidth > 1200){
                MyStaff.width(slide);
            }
        });
        slide.on('afterChange', function(event, slick, direction){
            if(window.innerWidth > 1200){
                MyStaff.width(slide);
            }
        });
    },
    width : function(slide){
        var width = parseInt($('.slick-list').css('width').replace('px',''));
        $(slide).find('.slide').each(function(){
            $(this).css('width',parseInt(width/4)+'px').removeClass('slick-text');
        });
        var active = $(slide).find('.slick-active').each(function(i,e){
            if(i == 1){
                $(this).addClass('slick-text').css('width',parseInt(width/2)+'px');
            }else{
                $(this).removeClass('slick-text');
            }
        });
    }
}
MyStaff.init();
SlideBlog = {
    init : function(){
        $('.slide-blog').each(function(){
            var id = $(this).data('id');
            SlideBlog.build(id);
        })
    },
    build : function(id){
        var slide_show = $('#slide-blog-'+id);
        slide_show.owlCarousel({
            nav:false,
            loop:true,
            autoplay:false,
            items:1
        });
        SlideBlog.listBlog();
        $(window).on('resize',function(){
            SlideBlog.listBlog();
        })
    },
    listBlog : function(){
        var h = parseInt($('.hybrid-container').find('.top').css('height').replace('px','')) + parseInt($('.hybrid-container').find('.bottom').css('height').replace('px',''));
        $('.hybrid-container').find('.article-item').css('height',h+'px');
    },
}
SlideBlog.init();
$(document).on('shopify:section:load', function (e) {
    var data = e.target.attributes;
    var array;
    for(var i in data){
        if(data[i].nodeValue.indexOf("}") > 0){
            array = data[i].nodeValue;
            break;
        }
    }
    console.log(JSON.parse(array));
    var section = JSON.parse(array);
    switch (section.type){
        case 'slide-show':
            SlideShow.build(section.id);
            break;
        case 'my-staff':
            MyStaff.build(section.id);
            break;
        case 'fancy-hybrid':
            SlideBlog.build(section.id);
            break;
    }
});

$(document).ready(function(){
  //alert();
  $('#pack-size').change(function(){
    var curr_val = $(this).val();	
    //$('#rc_duplicate_selector option[data-value='+curr_val+']').prop('selected','selected');
  });
});


// custom js for product page add to cart button  
(function ($) {
    var obj = function () {
    };

    obj.init = function () {

        if (window.location.pathname.match(/\/products\/.+/) && $("body.template-product").length) {
            obj.data = {
                name: $(".single-product .main-content-product .info h1").text().trim(),
                image: $(".single-product .main-content-product .slick-active.big-item > img").attr("src")
            };
            obj.addCSS().updateContent();
        }

        return obj;
    };

    obj.addCSS = function () {
        $("head").append(
            "<style type=\"text/css\">" +

            "body.atcp__popup-visible{" +
            "overflow:hidden !important;" +
            "}" +

            ".single-product .main-content-product .info .view-cart{" +
            "position:absolute !important;" +
            "width:1px !important;" +
            "height:1px !important;" +
            "opacity:0 !important;" +
            "overflow:hidden !important;" +
            "}" +

            ".atcp__bg{" +
            "display:none;" +
            "position:fixed;" +
            "top:0;" +
            "right:0;" +
            "bottom:0;" +
            "left:0;" +
            "background:rgba(43,43,43,.53);" +
            "z-index:99999998;" +
            "cursor:pointer;" +
            "-moz-transition:all .3s linear;" +
            "-webkit-transition:all .3s linear;" +
            "transition:all .3s linear;" +
            "animation:fadeIn .3s linear none;" +
            "}" +

            "body.atcp__popup-visible .atcp__bg{" +
            "display:block;" +
            "}" +

            ".atcp__container{" +
            "position:relative;" +
            "z-index:99999999;" +
            "}" +

            ".atcp__popup{" +
            "display:none;" +
            "position:absolute;" +
            "background:#fff;" +
            "box-shadow:0 1px 3px rgba(0,0,0,.2);" +
            "-moz-border-radius:3px;" +
            "-webkit-border-radius:3px;" +
            "border-radius:3px;" +
            "padding:25px 22.5px 15px;" +
            "text-align:center;" +
            "-moz-transition:all .3s linear;" +
            "-webkit-transition:all .3s linear;" +
            "transition:all .3s linear;" +
            "animation:fadeIn .3s linear none;" +
            "}" +

            "body.atcp__popup-visible .atcp__popup{" +
            "display:block;" +
            "}" +

            ".atcp__content{" +
            "display:table;" +
            "width:100%;" +
            "}" +

            ".atcp__close{" +
            "display:block;" +
            "position:absolute;" +
            "top:0;" +
            "right:0;" +
            "width:28px;" +
            "height:28px;" +
            "background:center / 14px no-repeat;" +
            "background-image:url(//dl.dropbox.com/s/lc4dun6cs0djk4q/dark-close-icon.png?dl=0);" +
            "border:0;" +
            "outline:0;" +
            "margin:0;" +
            "padding:0;" +
            "opacity:.5;" +
            "cursor:pointer;" +
            "-moz-transition:all .3s linear;" +
            "-webkit-transition:all .3s linear;" +
            "transition:all .3s linear;" +
            "}" +

            ".atcp__close:hover{" +
            "opacity:1;" +
            "}" +

            ".atcp__icon{" +
            "display:block;" +
            "position:absolute;" +
            "top:-14px;" +
            "left:calc(50% - 16px);" +
            "width:32px;" +
            "height:32px;" +
            "background:#50bd86;" +
            "background-image:-moz-linear-gradient(bottom,rgba(255,255,255,.25) 0%,rgba(255,255,255,0) 100%);" +
            "background-image:-webkit-linear-gradient(bottom,rgba(255,255,255,.25) 0%,rgba(255,255,255,0) 100%);" +
            "background-image:linear-gradient(to top,rgba(255,255,255,.25) 0%,rgba(255,255,255,0) 100%);" +
            "-moz-border-radius:50%;" +
            "-webkit-border-radius:50%;" +
            "border-radius:50%;" +
            "}" +

            ".atcp__icon:before{" +
            "content:\"\";" +
            "display:block;" +
            "position:absolute;" +
            "top:0;" +
            "right:0;" +
            "bottom:0;" +
            "left:0;" +
            "background:center / 16px no-repeat;" +
            "background-image:url(//dl.dropbox.com/s/oc0wn72dpzz1h5x/light-check-icon.png?dl=0);" +
            "}" +

            ".atcp__title{" +
            "font-size:16px;" +
            "color:rgba(0,0,0,.4);" +
            "margin-bottom:4px;" +
            "}" +

            ".atcp__subtitle{" +
            "font-size:21px;" +
            "color:#000;" +
            "margin-bottom:24px;" +
            "}" +

            ".atcp__actions{" +
            "display:table;" +
            "width:100%;" +
            "}" +

            ".atcp__shopping-btn," +
            ".atcp__cart-btn{" +
            "display:block;" +
            "background:orange;" +
            "outline:0;" +
            "border:0;" +
            "-moz-border-radius:3px;" +
            "-webkit-border-radius:3px;" +
            "border-radius:3px;" +
            "font-size:14px;" +
            "font-weight:normal;" +
            "text-transform:uppercase;" +
            "line-height:normal;" +
            "height:auto;" +
            "width:calc(50% - 5px);" +
            "float:left;" +
            "position:relative;" +
            "-moz-transition:all .3s linear;" +
            "-webkit-transition:all .3s linear;" +
            "transition:all .3s linear;" +
            "cursor:pointer;" +
            "}" +

            ".atcp__shopping-btn:before," +
            ".atcp__cart-btn:before{" +
            "content:\"\";" +
            "display:block;" +
            "position:absolute;" +
            "top:0;" +
            "right:0;" +
            "bottom:0;" +
            "width:30px;" +
            "background:center / 16px no-repeat;" +
            "}" +

            ".atcp__shopping-btn{" +
            "background:#fff;" +
            "color:rgba(0,0,0,.5);" +
            "border:1px solid rgba(0,0,0,.175);" +
            "padding:5px 7px 4px 17px;" +
            "margin-right:10px;" +
            "}" +

            ".atcp__shopping-btn:hover{" +
            "color:rgba(0,0,0,.7);" +
            "border-color:rgba(0,0,0,.375);" +
            "}" +

            ".atcp__shopping-btn:before{" +
            "left:0;" +
            "background-image:url(//dl.dropbox.com/s/mwwsulg3zb5faem/dark-left-icon.png?dl=0);" +
            "opacity:.5;" +
            "}" +

            ".atcp__shopping-btn:hover:before{" +
            "opacity:.75;" +
            "}" +

            ".atcp__cart-btn{" +
            "padding:6px 18px 5px 8px;" +
            "background:#f00;" +
            "color:#fff;" +
            "}" +

            ".atcp__cart-btn:hover{" +
            "color:#fff;" +
            "background:#000;" +
            "}" +

            ".atcp__cart-btn:before{" +
            "-moz-border-radius:0 3px 3px 0;" +
            "-webkit-border-radius:0 3px 3px 0;" +
            "border-radius:0 3px 3px 0;" +
            "right:0;" +
            "background-image:url(//dl.dropbox.com/s/682x21dtp5orfhe/light-right-icon.png?dl=0);" +
            "}" +


            /* Mobile */
            "@media only screen and (max-width:767px){" +

            ".atcp__popup{" +
            "right:20px;" +
            "left:20px;" +
            "position:fixed;" +
            "top:calc(50% - 72px);" +
            "}" +

            ".atcp__popup:before{" +
            "left:calc(82px - 12px);" +
            "}" +

            "}" +
            /* /Mobile */


            /* Tablet && Desktop */
            "@media only screen and (min-width:768px){" +

            ".atcp__popup{" +
            "width:360px;" +
            "left:calc(82px - 180px);" +
            "bottom:10px;" +
            "}" +

            ".atcp__popup:before{" +
            "content:\"\";" +
            "display:block;" +
            "position:absolute;" +
            "top:100%;" +
            "right:calc(50% - 12px);" +
            "border-top:5px solid #fff;" +
            "border-right:12px solid transparent;" +
            "border-left:12px solid transparent;" +
            "}" +

            "}" +
            /* /Tablet && Desktop */


            /* Desktop */
            "@media only screen and (min-width:1250px){" +

            "}" +
            /* /Desktop */

            "</style>"
        );

        return obj;
    };

    obj.updateContent = function () {
        var addToCartScection = $(".single-product .main-content-product .info .link-add-to-cart");
        addToCartScection.prepend(
            "<div class=\"atcp__bg\"></div>" +
            "<div class=\"atcp__container\">" +
            "<div class=\"atcp__popup\">" +
            "<button type=\"button\" class=\"atcp__close\"></button>" +
            "<i class=\"atcp__image\" style=\"background-image:url(" + obj.data.image + ");\"></i>" +
            "<i class=\"atcp__icon\"></i>" +
            "<div class=\"atcp__title\">" + obj.data.name + "</div>" +
            "<div class=\"atcp__subtitle\">Added to Your Cart</div>" +
            "<div class=\"atcp__actions\">" +
            "<button type=\"type\" class=\"atcp__shopping-btn\">Continue Shopping</button>" +
            "<a href=\"/cart\" class=\"atcp__cart-btn\">View Your Cart</a>" +
            "</div>" + /* /.atcp__actions */
            "</div>" + /* /.atcp__popup */
            "</div>" /* /.atcp__container */
        );

        $(document).on("click", ".single-product .main-content-product .info .link-add-to-cart .button", function () {
            obj.checkCartMessageChecks = 0;
            obj.checkCartMessageByCircle = setInterval(obj.checkCartMessage, 400);
        });

        $(document).on("click", ".atcp__shopping-btn,.atcp__bg,.atcp__close", function (e) {
            e.preventDefault();
            e.stopPropagation();
            $("body").removeClass("atcp__popup-visible");
        });

        return obj;
    };

    obj.checkCartMessage = function () {
        var cartMessage = $(".single-product .main-content-product .info .view-cart");

        if (cartMessage.length) {
            $("body").addClass("atcp__popup-visible");
            clearInterval(obj.checkCartMessageByCircle);

        } else if (obj.checkCartMessageChecks > 20) {
            clearInterval(obj.checkCartMessageByCircle);
            obj.checkCartMessageChecks = 0;

        } else {
            obj.checkCartMessageChecks++;
        }

        return obj;
    };

    obj.init();

}(jQuery));


// Convert selector swatches ******************************

(function ($) {
    var obj = this;

    obj.init = function () {
      
      //--tim: changed from (/^\/products\/.+/) to (/\/products\/.+/) so that it matches collection-aware product page URLS too

        if (window.location.pathname.match(/\/products\/.+/)
            && $("select.single-option-variant > option:contains(\"SINGLE PACK\")").length
            && $("select.single-option-variant > option:contains(\"4-PACK\")").length
            && $("select.single-option-variant > option:contains(\"8-PACK\")").length
            && $("body.template-product").length) {
            obj.addCSS().updateContent();
        }
      
      else if (window.location.pathname.match(/\/products\/.+/)
            && $("select.single-option-variant > option:contains(\"SINGLE PACK\")").length
            && $("select.single-option-variant > option:contains(\"2-PACK\")").length
            && $("select.single-option-variant > option:contains(\"4-PACK\")").length
            && $("body.template-product").length) {
            obj.addCSS().updateContent2();
        }
      
       else if (window.location.pathname.match(/\/products\/.+/)
            && $("select.single-option-variant > option:contains(\"4-STICKS\")").length
            && $("select.single-option-variant > option:contains(\"12-STICKS\")").length
            && $("select.single-option-variant > option:contains(\"24-STICKS\")").length
            && $("body.template-product").length) {
            obj.addCSS().updateContent3();
        }
      
       else if (window.location.pathname.match(/\/products\/.+/)
            && $("select.single-option-variant > option:contains(\"6-STICKS\")").length
            && $("select.single-option-variant > option:contains(\"18-STICKS\")").length
            && $("select.single-option-variant > option:contains(\"36-STICKS\")").length
            && $("body.template-product").length) {
            obj.addCSS().updateContent4();
        }
        
       else if (window.location.pathname.match(/\/products\/.+/)
            && $("select.single-option-variant > option:contains(\"5-STICKS\")").length
            && $("select.single-option-variant > option:contains(\"15-STICKS\")").length
            && $("select.single-option-variant > option:contains(\"30-STICKS\")").length
            && $("body.template-product").length) {
            obj.addCSS().updateContent5();
        }
else if (window.location.pathname.match(/\/products\/.+/)
            && $("select.single-option-variant > option:contains(\"2-PACK\")").length
            && $("select.single-option-variant > option:contains(\"4-PACK\")").length
            && $("select.single-option-variant > option:contains(\"8-PACK\")").length
            && $("body.template-product").length) {
            obj.addCSS().updateContent6();

       }


        return obj;
    };

    obj.addCSS = function () {

        $("head").append(
            "<style type=\"text/css\">" +

            "select.single-option-variant{" +
            "position:absolute !important;" +
            "width:1px !important;" +
            "height:1px !important;" +
            "padding:0 !important;" +
            "margin:0 !important;" +
            "border:0 !important;" +
            "opacity:0 !important;" +
            "}" +

            /* Quantity */
            ".single-product .main-content-product .info .variant-qty{" +
            "border-top:0;" +
            "}" +
            /* /Quantity */

            ".npps__container{" +
            "margin:-10px 0 11px;" +
            "}" +

            ".npps__title{" +
            "font-size:14px;" +
            "margin-bottom:16px;" +
            "position:relative;" +
            "}" +

            ".npps__title:before{" +
            "content:\"\";" +
            "position:absolute;" +
            "top:11px;" +
            "right:0;" +
            "left:0;" +
            "border-bottom:1px solid rgba(0,0,0,.1);" +
            "display:block;" +
            "}" +

            ".npps__title span{" +
            "display:table;" +
            "position:relative;" +
            "background:#fff;" +
            "padding:0 20px;" +
            "margin:0 auto;" +
            "}" +

            ".npps__sizes-list{" +
            "display:table;" +
            "margin:0;" +
            "padding:0;" +
            // "border:1px solid rgba(0,0,0,.333);" +
            // "border-color:blue;" +
            "list-style:none;" +
            "width:100%;" +
            "}" +

            ".npps__size{" +
            "background:rgba(0,0,0,.0125);" +
            "float:left;" +
            "width:33.333%;" +
            "position:relative;" +
            "box-sizing:border-box;" +
            "padding:9px 5px;" +
            "cursor:pointer;" +
            "border:1px solid rgba(0,0,0,.333);" +
            "}" +

            ".npps__size-disabled{" +
            "opacity:.5;" +
            "cursor:default;" +
            "}" +

            ".npps__sizes-list > .npps__size:first-child{" +
            "-moz-border-radius:3px 0 0 3px;" +
            "-webkit-border-radius:3px 0 0 3px;" +
            "border-radius:3px 0 0 3px;" +
            "border-left-width:1px;" +
            "}" +

            ".npps__sizes-list > .npps__size:last-child{" +
            "-moz-border-radius:0 3px 3px 0;" +
            "-webkit-border-radius:0 3px 3px 0;" +
            "border-radius:0 3px 3px 0;" +
            "}" +

            ".npps__sizes-list > .npps__size:not(:last-child){" +
            "border-right-width:0;" +
            "}" +

            ".npps__sizes-list > .npps__size:not(:first-child){" +
            "border-left:1px solid rgba(0,0,0,.15);" +
            "}" +

            ".npps__size-active{" +
            "cursor:default;" +
            "z-index:1;" +
            "}" +

            ".npps__size-active:before{" +
            "content:\"\";" +
            "display:block;" +
            "position:absolute;" +
            "top:-4px;" +
            "right:-1px;" +
            "bottom:-4px;" +
            "left:-1px;" +
            "-moz-border-radius:4px;" +
            "-webkit-border-radius:4px;" +
            "border-radius:4px;" +
            "border:2px solid #96d2b8;" +
            "background:#fff;" +
            "}" +

            ".npps__size-icon{" +
            "position:relative;" +
            "height:25px;" +
            "display:block;" +
            "background:center no-repeat;" +
            "opacity:.6;" +
            "margin:0 0 10px;" +
            "-moz-transition:all .3s linear;" +
            "-webkit-transition:all .3s linear;" +
            "transition:all .3s linear;" +
            "}" +

            ".npps__size:hover .npps__size-icon," +
            ".npps__size-active .npps__size-icon{" +
            "opacity:1;" +
            "}" +

            ".npps__1pack-size .npps__size-icon{" +
            "background-image:url(//dl.dropbox.com/s/3svtir7i91ui3hs/1-pack-icon.png?dl=0);" +
            "background-size:14px;" +
            "}" +

            ".npps__size-active.npps__1pack-size .npps__size-icon{" +
            "background-image:url(//dl.dropbox.com/s/h0a7agss6kyj827/green-1-pack-icon.png?dl=0);" +
            "}" +
          
            ".npps__2pack-size .npps__size-icon{" +
            "background-image:url(//knightsky.box.com/shared/static/6naas3ms5dgmbui44b7v36jacwsp70en.png);" +
            "background-size:14px;" +
            "}" +

            ".npps__size-active.npps__2pack-size .npps__size-icon{" +
            "background-image:url(//knightsky.box.com/shared/static/vv4z14ia73cmjirfjdabz9dc3iwof6te.png);" +
            "}" +
                    
            ".npps__4pack-size .npps__size-icon{" +
            "background-image:url(//dl.dropbox.com/s/9qsmaeiw0wg59mr/4-pack-icon.png?dl=0);" +
            "background-size:19px;" +
            "}" +

            ".npps__size-active.npps__4pack-size .npps__size-icon{" +
            "background-image:url(//dl.dropbox.com/s/d07ypfm0z3kghjr/green-4-pack-icon.png?dl=0);" +
            "}" +

            ".npps__8pack-size .npps__size-icon{" +
            "background-image:url(//dl.dropbox.com/s/ghl397ctcvv4rul/8-pack-icon.png?dl=0);" +
            "background-size:32px;" +
            "}" +

            ".npps__size-active.npps__8pack-size .npps__size-icon{" +
            "background-image:url(//dl.dropbox.com/s/2bkycqxr5qc82kl/green-8-pack-icon.png?dl=0);" +
            "}" +

            ".npps__size-disabled .npps__size-icon{" +
            "opacity:0 !important;" +
            "}" +

            ".npps__size-title{" +
            "display:block;" +
            "font-size:14px;" +
            "line-height:1;" +
            "text-align:center;" +
            "color:#666;" +
            "position:relative;" +
            "-moz-transition:all .3s linear;" +
            "-webkit-transition:all .3s linear;" +
            "transition:all .3s linear;" +
            "}" +

            ".npps__size-disabled .npps__size-title{" +
            "bottom:24px;" +
            "}" +

            ".npps__size-subtitle{" +
            "position:absolute;" +
            "right:0;" +
            "bottom:15px;" +
            "left:0;" +
            "text-align:center;" +
            "color:#f92c2c;" +
            "font-size:12px;" +
            "line-height:1;" +
            "}" +

            ".npps__size:not(.npps__size-disabled):hover .npps__size-title{" +
            "color:#000;" +
            "}" +

            ".npps__size-active .npps__size-title{" +
            "color:#4ab785 !important;" +
            "}" +

            "</style>"
        );

        return obj;
    };

    obj.updateContent = function () {
        var sizes = $("select.single-option-variant > option");

        if (sizes.length) {
            var sizesList = $("select.single-option-variant");
            sizesList.after(
                "<div class=\"npps__container\">" +
                "<div class=\"npps__title\">" +
                "<span>Choose Your Pack Size</span>" +
                "</div> " + /* /.npps__title */
                "<ul class=\"npps__sizes-list\"></ul>" +
                "</div>"
            );

            var newSizesList = $(".npps__sizes-list");

            sizes.each(function () {
                var size = $(this);
                var sizeSoldOut = false;
                var sizeTitle = size.text().trim();
                var sizeValue = size.val();

                if (sizeTitle.match(/^(SINGLE PACK|2-PACK|4-PACK|8-PACK)(| - Sold out)$/)) {

                    if (sizeTitle.match(/^(SINGLE PACK|2-PACK|4-PACK|8-PACK) - Sold out$/)) {
                        sizeSoldOut = true;
                        sizeTitle = sizeTitle.replace(/^(SINGLE PACK|2-PACK|4-PACK|8-PACK) - Sold out$/, "$1");
                    }
                    newSizesList.append(
                        "<li class=\"npps__size" + (sizeSoldOut ? " npps__size-disabled" : "") + (sizeTitle == "8-PACK" ? " npps__8pack-size" : (sizeTitle == "4-PACK" ? " npps__4pack-size" : (sizeTitle == "SINGLE PACK" ? " npps__1pack-size" : ""))) + "\" data-title=\"" + sizeTitle + "\" data-value=\"" + sizeValue + "\">" +
                        "<i class=\"npps__size-icon\"></i>" +
                        "<span class=\"npps__size-title\">" + sizeTitle + "</span>" +
                        (sizeSoldOut ? "<span class=\"npps__size-subtitle\">Sold Out</span>" : "") +
                        "</li>"
                    );

                    /* Smartrr Custom JS
                     * Set default variant based on url
                     */
                    var curURL = window.location.href;
                      function getVariant(string, character) {
                        if(string.includes("=")) {
                          return string.substring(string.indexOf(character) + 1);
                        } else {
                          return;
                        }
                      }

                    async function setDefaultVariant() {
                      var defaultVariant = await getVariant(curURL, "=");
                      if(defaultVariant && defaultVariant == sizeValue) {
                        obj.setSize(sizeTitle, sizeValue);
                      } 
                      
                      if(!defaultVariant) {
                        obj.setSize("4-PACK", sizes[2].value);
                      }
                    }

                    setDefaultVariant();
                    /* End Smartrr Custom JS */
                    
                  
                    /*
                     * Commented out by Smartrr
                     *
                    if (sizeTitle == "4-PACK" && !sizeSoldOut) {
                        obj.setSize(sizeTitle, sizeValue);
                    }
                    */
                    
                    
                }
            });

            var newActiveSize = newSizesList.children(".npps__size-active");
            /*
             * Commented out by Smartrr as this is setting default variant behavior
             *
            if (!newActiveSize.length) {
               newSizesList.children(":not(.npps__size-disabled):first").addClass("npps__size-active");
            }
            */
        }

        $(document).on("click", ".npps__size:not(.npps__size-active):not(.npps__size-disabled)", function () {
            var size = $(this);
            var sizeTitle = size.find(".npps__size-title").text().trim();
            var sizeValue = size.attr("data-value");
            obj.setSize(sizeTitle, sizeValue);
        });

        return obj;
    };
  
  
  obj.updateContent2 = function () {
        var sizes = $("select.single-option-variant > option");

        if (sizes.length) {
            var sizesList = $("select.single-option-variant");
            sizesList.after(
                "<div class=\"npps__container\">" +
                "<div class=\"npps__title\">" +
                "<span>Choose Your Pack Size</span>" +
                "</div> " + /* /.npps__title */
                "<ul class=\"npps__sizes-list\"></ul>" +
                "</div>"
            );

            var newSizesList = $(".npps__sizes-list");

            sizes.each(function () {
                var size = $(this);
                var sizeSoldOut = false;
                var sizeTitle = size.text().trim();
                var sizeValue = size.val();

                if (sizeTitle.match(/^(SINGLE PACK|2-PACK|4-PACK)(| - Sold out)$/)) {

                    if (sizeTitle.match(/^(SINGLE PACK|2-PACK|4-PACK) - Sold out$/)) {
                        sizeSoldOut = true;
                        sizeTitle = sizeTitle.replace(/^(SINGLE PACK|2-PACK|4-PACK) - Sold out$/, "$1");
                    }
                    newSizesList.append(
                        "<li class=\"npps__size" + (sizeSoldOut ? " npps__size-disabled" : "") + (sizeTitle == "4-PACK" ? " npps__4pack-size" : (sizeTitle == "2-PACK" ? " npps__2pack-size" : (sizeTitle == "SINGLE PACK" ? " npps__1pack-size" : ""))) + "\" data-title=\"" + sizeTitle + "\" data-value=\"" + sizeValue + "\">" +
                        "<i class=\"npps__size-icon\"></i>" +
                        "<span class=\"npps__size-title\">" + sizeTitle + "</span>" +
                        (sizeSoldOut ? "<span class=\"npps__size-subtitle\">Sold Out</span>" : "") +
                        "</li>"
                    );

                                        /* Smartrr Custom JS
                     * Set default variant based on url
                     */
                    var curURL = window.location.href;
                      function getVariant(string, character) {
                        if(string.includes("=")) {
                          return string.substring(string.indexOf(character) + 1);
                        } else {
                          return;
                        }
                      }

                    async function setDefaultVariant() {
                      var defaultVariant = await getVariant(curURL, "=");
                      if(defaultVariant && defaultVariant == sizeValue) {
                        obj.setSize(sizeTitle, sizeValue);
                      } 
                      
                      if(!defaultVariant) {
                        obj.setSize("2-PACK", sizes[2].value);
                      }
                    }

                    setDefaultVariant();
                    /* End Smartrr Custom JS */


                    /*
                     * Commented out by Smartrr
                     *

                    if (sizeTitle == "2-PACK" && !sizeSoldOut) {
                        obj.setSize(sizeTitle, sizeValue);
                    }
                    */
                }
            });

            var newActiveSize = newSizesList.children(".npps__size-active");

            /*
             * Commented out by Smartrr as this is setting default variant behavior
             *
             
            if (!newActiveSize.length) {
                newSizesList.children(":not(.npps__size-disabled):first").addClass("npps__size-active");
            }
            */
        }

        $(document).on("click", ".npps__size:not(.npps__size-active):not(.npps__size-disabled)", function () {
            var size = $(this);
            var sizeTitle = size.find(".npps__size-title").text().trim();
            var sizeValue = size.attr("data-value");
            obj.setSize(sizeTitle, sizeValue);
        });

        return obj;
    };

  
    
obj.updateContent3 = function () {
        var sizes = $("select.single-option-variant > option");

        if (sizes.length) {
            var sizesList = $("select.single-option-variant");
            sizesList.after(
                "<div class=\"npps__container\">" +
                "<div class=\"npps__title\">" +
                "<span>Choose Your Stick Count</span>" +
                "</div> " + /* /.npps__title */
                "<ul class=\"npps__sizes-list\"></ul>" +
                "</div>"
            );

            var newSizesList = $(".npps__sizes-list");

            sizes.each(function () {
                var size = $(this);
                var sizeSoldOut = false;
                var sizeTitle = size.text().trim();
                var sizeValue = size.val();

                if (sizeTitle.match(/^(4-STICKS|12-STICKS|24-STICKS)(| - Sold out)$/)) {

                    if (sizeTitle.match(/^(4-STICKS|12-STICKS|24-STICKS) - Sold out$/)) {
                        sizeSoldOut = true;
                        sizeTitle = sizeTitle.replace(/^(4-STICKS|12-STICKS|24-STICKS) - Sold out$/, "$1");
                    }
                    newSizesList.append(
                        "<li class=\"npps__size" + (sizeSoldOut ? " npps__size-disabled" : "") + (sizeTitle == "24-STICKS" ? " npps__24pack-size" : (sizeTitle == "12-STICKS" ? " npps__12pack-size" : (sizeTitle == "4-STICKS" ? " npps__4stick-size" : ""))) + "\" data-title=\"" + sizeTitle + "\" data-value=\"" + sizeValue + "\">" +
                        /* "<i class=\"npps__size-icon\"></i>" + */
                        "<span class=\"npps__size-title\">" + sizeTitle + "</span>" +
                        (sizeSoldOut ? "<span class=\"npps__size-subtitle\">Sold Out</span>" : "") +
                        "</li>"
                    );

                    /* Smartrr Custom JS
                     * Set default variant based on url
                     */
                    var curURL = window.location.href;
                      function getVariant(string, character) {
                        if(string.includes("=")) {
                          return string.substring(string.indexOf(character) + 1);
                        } else {
                          return;
                        }
                      }

                    async function setDefaultVariant() {
                      var defaultVariant = await getVariant(curURL, "=");
                      if(defaultVariant && defaultVariant == sizeValue) {
                        obj.setSize(sizeTitle, sizeValue);
                      } 
                      
                      if(!defaultVariant) {
                        obj.setSize("12-STICKS", sizes[2].value);
                      }
                    }

                    setDefaultVariant();
                    /* End Smartrr Custom JS */

                    /*
                     * Commented out by Smartrr
                     *
                    if (sizeTitle == "12-STICKS" && !sizeSoldOut) {
                        obj.setSize(sizeTitle, sizeValue);
                    }
                    */
                }
            });

            var newActiveSize = newSizesList.children(".npps__size-active");
            /*
             * Commented out by Smartrr as this is setting default variant behavior
             *
            if (!newActiveSize.length) {
                newSizesList.children(":not(.npps__size-disabled):first").addClass("npps__size-active");
            }
            */
        }

        $(document).on("click", ".npps__size:not(.npps__size-active):not(.npps__size-disabled)", function () {
            var size = $(this);
            var sizeTitle = size.find(".npps__size-title").text().trim();
            var sizeValue = size.attr("data-value");
            obj.setSize(sizeTitle, sizeValue);
        });

        return obj;
    };
  
     obj.updateContent4 = function () {
        var sizes = $("select.single-option-variant > option");

        if (sizes.length) {
            var sizesList = $("select.single-option-variant");
            sizesList.after(
                "<div class=\"npps__container\">" +
                "<div class=\"npps__title\">" +
                "<span>Choose Your Stick Count</span>" +
                "</div> " + /* /.npps__title */
                "<ul class=\"npps__sizes-list\"></ul>" +
                "</div>"
            );

            var newSizesList = $(".npps__sizes-list");

            sizes.each(function () {
                var size = $(this);
                var sizeSoldOut = false;
                var sizeTitle = size.text().trim();
                var sizeValue = size.val();

                if (sizeTitle.match(/^(6-STICKS|18-STICKS|36-STICKS)(| - Sold out)$/)) {

                    if (sizeTitle.match(/^(6-STICKS|18-STICKS|36-STICKS) - Sold out$/)) {
                        sizeSoldOut = true;
                        sizeTitle = sizeTitle.replace(/^(6-STICKS|18-STICKS|36-STICKS) - Sold out$/, "$1");
                    }
                    newSizesList.append(
                        "<li class=\"npps__size" + (sizeSoldOut ? " npps__size-disabled" : "") + (sizeTitle == "36-STICKS" ? " npps__36pack-size" : (sizeTitle == "18-STICKS" ? " npps__18pack-size" : (sizeTitle == "6-STICKS" ? " npps__6stick-size" : ""))) + "\" data-title=\"" + sizeTitle + "\" data-value=\"" + sizeValue + "\">" +
                        /* "<i class=\"npps__size-icon\"></i>" + */
                        "<span class=\"npps__size-title\">" + sizeTitle + "</span>" +
                        (sizeSoldOut ? "<span class=\"npps__size-subtitle\">Sold Out</span>" : "") +
                        "</li>"
                    );

                    /* Smartrr Custom JS
                     * Set default variant based on url
                     */
                    var curURL = window.location.href;
                      function getVariant(string, character) {
                        if(string.includes("=")) {
                          return string.substring(string.indexOf(character) + 1);
                        } else {
                          return;
                        }
                      }

                    async function setDefaultVariant() {
                      var defaultVariant = await getVariant(curURL, "=");
                      if(defaultVariant && defaultVariant == sizeValue) {
                        obj.setSize(sizeTitle, sizeValue);
                      } 
                      
                      if(!defaultVariant) {
                        obj.setSize("18-STICKS", sizes[2].value);
                      }
                    }

                    setDefaultVariant();
                    /* End Smartrr Custom JS */

                    /*
                     * Commented out by Smartrr
                     *
                    if (sizeTitle == "18-STICKS" && !sizeSoldOut) {
                        obj.setSize(sizeTitle, sizeValue);
                    }
                    */
                }
            });

            var newActiveSize = newSizesList.children(".npps__size-active");
            /*
             * Commented out by Smartrr as this is setting default variant behavior
             * 
            if (!newActiveSize.length) {
                newSizesList.children(":not(.npps__size-disabled):first").addClass("npps__size-active");
            }
            */
        }

        $(document).on("click", ".npps__size:not(.npps__size-active):not(.npps__size-disabled)", function () {
            var size = $(this);
            var sizeTitle = size.find(".npps__size-title").text().trim();
            var sizeValue = size.attr("data-value");
            obj.setSize(sizeTitle, sizeValue);
        });

        return obj;
    };


       obj.updateContent5 = function () {
        var sizes = $("select.single-option-variant > option");

        if (sizes.length) {
            var sizesList = $("select.single-option-variant");
            sizesList.after(
                "<div class=\"npps__container\">" +
                "<div class=\"npps__title\">" +
                "<span>Choose Your Stick Count</span>" +
                "</div> " + /* /.npps__title */
                "<ul class=\"npps__sizes-list\"></ul>" +
                "</div>"
            );

            var newSizesList = $(".npps__sizes-list");

            sizes.each(function () {
                var size = $(this);
                var sizeSoldOut = false;
                var sizeTitle = size.text().trim();
                var sizeValue = size.val();

                if (sizeTitle.match(/^(5-STICKS|15-STICKS|30-STICKS)(| - Sold out)$/)) {

                    if (sizeTitle.match(/^(5-STICKS|15-STICKS|30-STICKS) - Sold out$/)) {
                        sizeSoldOut = true;
                        sizeTitle = sizeTitle.replace(/^(5-STICKS|15-STICKS|30-STICKS) - Sold out$/, "$1");
                    }
                    newSizesList.append(
                        "<li class=\"npps__size" + (sizeSoldOut ? " npps__size-disabled" : "") + (sizeTitle == "30-STICKS" ? " npps__30pack-size" : (sizeTitle == "15-STICKS" ? " npps__15pack-size" : (sizeTitle == "5-STICKS" ? " npps__5stick-size" : ""))) + "\" data-title=\"" + sizeTitle + "\" data-value=\"" + sizeValue + "\">" +
                        /* "<i class=\"npps__size-icon\"></i>" + */
                        "<span class=\"npps__size-title\">" + sizeTitle + "</span>" +
                        (sizeSoldOut ? "<span class=\"npps__size-subtitle\">Sold Out</span>" : "") +
                        "</li>"
                    );

                    /* Smartrr Custom JS
                     * Set default variant based on url
                     */
                    var curURL = window.location.href;
                      function getVariant(string, character) {
                        if(string.includes("=")) {
                          return string.substring(string.indexOf(character) + 1);
                        } else {
                          return;
                        }
                      }

                    async function setDefaultVariant() {
                      var defaultVariant = await getVariant(curURL, "=");
                      if(defaultVariant && defaultVariant == sizeValue) {
                        obj.setSize(sizeTitle, sizeValue);
                      } 
                      
                      if(!defaultVariant) {
                        obj.setSize("18-STICKS", sizes[2].value);
                      }
                    }

                    setDefaultVariant();
                    /* End Smartrr Custom JS */

                    /*
                     * Commented out by Smartrr
                     *
                    if (sizeTitle == "15-STICKS" && !sizeSoldOut) {
                        obj.setSize(sizeTitle, sizeValue);
                    }
                    */
                }
            });

            var newActiveSize = newSizesList.children(".npps__size-active");
            /*
             * Commented out by Smartrr as this is setting default variant behavior
             *
            if (!newActiveSize.length) {
                newSizesList.children(":not(.npps__size-disabled):first").addClass("npps__size-active");
            }
            */
        }

        $(document).on("click", ".npps__size:not(.npps__size-active):not(.npps__size-disabled)", function () {
            var size = $(this);
            var sizeTitle = size.find(".npps__size-title").text().trim();
            var sizeValue = size.attr("data-value");
            obj.setSize(sizeTitle, sizeValue);
        });

        return obj;
    };
  
  obj.updateContent6 = function () {
        var sizes = $("select.single-option-variant > option");

        if (sizes.length) {
            var sizesList = $("select.single-option-variant");
            sizesList.after(
                "<div class=\"npps__container\">" +
                "<div class=\"npps__title\">" +
                "<span>Choose Your Pack Size</span>" +
                "</div> " + /* /.npps__title */
                "<ul class=\"npps__sizes-list\"></ul>" +
                "</div>"
            );

            var newSizesList = $(".npps__sizes-list");

            sizes.each(function () {
                var size = $(this);
                var sizeSoldOut = false;
                var sizeTitle = size.text().trim();
                var sizeValue = size.val();

                if (sizeTitle.match(/^(2-PACK|4-PACK|8-PACK)(| - Sold out)$/)) {

                    if (sizeTitle.match(/^(2-PACK|4-PACK|8-PACK) - Sold out$/)) {
                        sizeSoldOut = true;
                        sizeTitle = sizeTitle.replace(/^(2-PACK|4-PACK|8-PACK) - Sold out$/, "$1");
                    }
                    newSizesList.append(
                        "<li class=\"npps__size" + (sizeSoldOut ? " npps__size-disabled" : "") + (sizeTitle == "8-PACK" ? " npps__8pack-size" : (sizeTitle == "4-PACK" ? " npps__4pack-size" : (sizeTitle == "2-PACK" ? " npps__2pack-size" : ""))) + "\" data-title=\"" + sizeTitle + "\" data-value=\"" + sizeValue + "\">" +
                        "<i class=\"npps__size-icon\"></i>" +
                        "<span class=\"npps__size-title\">" + sizeTitle + "</span>" +
                        (sizeSoldOut ? "<span class=\"npps__size-subtitle\">Sold Out</span>" : "") +
                        "</li>"
                    );

                    /* Smartrr Custom JS
                     * Set default variant based on url
                     */
                    var curURL = window.location.href;
                      function getVariant(string, character) {
                        if(string.includes("=")) {
                          return string.substring(string.indexOf(character) + 1);
                        } else {
                          return;
                        }
                      }

                    async function setDefaultVariant() {
                      var defaultVariant = await getVariant(curURL, "=");
                      if(defaultVariant && defaultVariant == sizeValue) {
                        obj.setSize(sizeTitle, sizeValue);
                      } 
                      
                      if(!defaultVariant) {
                        obj.setSize("4-PACK", sizes[2].value);
                      }
                    }

                    setDefaultVariant();
                    /* End Smartrr Custom JS */
                    
                  
                    /*
                     * Commented out by Smartrr
                     *
                    if (sizeTitle == "4-PACK" && !sizeSoldOut) {
                        obj.setSize(sizeTitle, sizeValue);
                    }
                    */
                    
                    
                }
            });

            var newActiveSize = newSizesList.children(".npps__size-active");
            /*
             * Commented out by Smartrr as this is setting default variant behavior
             *
            if (!newActiveSize.length) {
               newSizesList.children(":not(.npps__size-disabled):first").addClass("npps__size-active");
            }
            */
        }

        $(document).on("click", ".npps__size:not(.npps__size-active):not(.npps__size-disabled)", function () {
            var size = $(this);
            var sizeTitle = size.find(".npps__size-title").text().trim();
            var sizeValue = size.attr("data-value");
            obj.setSize(sizeTitle, sizeValue);
        });

        return obj;
    };
  
  
    obj.setSize = function (sizeTitle, sizeValue) {
        var size = $(".npps__size[data-title=\"" + sizeTitle + "\"]");
        size.addClass("npps__size-active").siblings(".npps__size-active").removeClass("npps__size-active");

        var originalSizesList = $("select.single-option-variant");
        originalSizesList.val(sizeValue).trigger("change");

        var event = new Event("change");
        originalSizesList[0].dispatchEvent(event);

        var originalSizes = meta.product.variants;

        for (var i = 0; i < originalSizes.length; i++) {
            var originalSize = originalSizes[i];

            if (originalSize.public_title == sizeTitle) {
                var optionInput = $(".variant-qty > input[type=\"hidden\"][data-productid]");
                optionInput.val(originalSize.id);
            }
        }

        return obj;
    };
  
  



    obj.init();

}(jQuery));

/* WCZ#005 */
!function(n){var o=function(){};o.init=function(){return/^(\/search|\/[0-9]+\/checkouts\/.+)$/.test(window.location.pathname)||o.addCSS().updateContent(),o},o.addCSS=function(){return n("head").append('<style type="text/css">.nhs__form{display:block;position:relative;padding-right:90px;}.nhs__input{display:block;padding:0 16px !important;font-size:14px;width:100%;height:34px !important;border:0 !important;-moz-border-radius:0 !important;-webkit-border-radius:0 !important;border-radius:0 !important;outline:0 !important;background:#fff !important;color:#000 !important;}.nhs__btn{display:block;text-align:center;padding:6px 0 4px 20px;box-sizing:border-box;border:0;outline:0;-moz-border-radius:0 !important;-webkit-border-radius:0 !important;border-radius:0 !important;background:red;color:#fff;font-size:14px;text-transform:uppercase;position:absolute;top:0;right:0;bottom:0;width:90px;cursor:pointer;}.nhs__btn:before{content:"";display:block;position:absolute;top:0;bottom:0;left:0;width:32px;background:center / 18px no-repeat;background-image:url(//dl.dropbox.com/s/0cbegqw6u4da1om/light-search-icon.png?dl=0);}@media only screen and (max-width:767px){#shopify-section-header > header.header{padding-bottom:45px !important;position:relative;}.nhs__container{position:absolute;right:0;bottom:0;left:0;background:#232222;padding:10px 15px;}}@media only screen and (min-width:768px){.nhs__container{width:291px;}}@media only screen and (min-width:768px) and (max-width:992px){.top-bar-menu > .container{position:relative;}.nhs__container{position:absolute;top:44px;right:66px;}}@media only screen and (min-width:993px){.nhs__container{float:right;margin:8px 0 0 30px;}}</style>'),o},o.updateContent=function(){var t=n(".top-bar-menu > .container");return t.length&&t.prepend('<div class="nhs__container"><form class="nhs__form" action="/search" method="get"><input autocomplete="off" type="text" name="q" class="nhs__input" placeholder="Find your products"/><button type="submit" class="nhs__btn">Search</button> </form></div>'),o},o.init()}(jQuery);
/* /WCZ#005 */

/* WCZ#010 */
!function(c){var i=function(){};i.init=function(){return window.location.pathname.match(/\/products\/.+/)&&c('select.single-option-variant > option:contains("SINGLE PACK")').length&&c('select.single-option-variant > option:contains("4-PACK")').length&&c('select.single-option-variant > option:contains("8-PACK")').length&&c("body.template-product").length&&i.addCSS().updateContent(),i},i.addCSS=function(){return c("head").append('<style type="text/css">.npps__container{margin-top:-20px;position:relative;background:#fff;}.npps__sizes-list{margin-bottom:29px !important;}.npps__size{padding:5px 3px 6px !important;border-color:rgb(158,158,158) !important;}.npps__size-active:before{top:-7px !important;bottom:-7px !important;}.npps__size-icon{margin-bottom:3px !important;}.npps__size:not(.npps__size-active) .npps__size-icon{opacity:.5;}.npps__1pack-size .npps__size-icon{background-size:12px !important;}.npps__4pack-size .npps__size-icon{background-size:18px !important;}.npps__8pack-size .npps__size-icon{background-size:24px !important;}.npps__size-title{color:#888 !important;}.npps__size-discount{height:20px;display:block;font-size:12px;text-align:center;position:relative;text-transform:uppercase;padding:5px 4px 3px;margin:6px -4px -11px;color:#40b881;-moz-border-radius:0 0 3px 3px; -webkit-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;line-height:1;}.npps__size:not(.npps__size-active) .npps__size-discount{background:#fff;background-image:-moz-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:-webkit-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:linear-gradient(to bottom,#fcfcfc 0%,#fff 100%);display:table;margin-right:auto;margin-left:auto;}.npps__1pack-size .npps__size-discount{opacity:0 !important;}.npps__size-active:before{border-color:#40b881 !important;}.npps__size-active .npps__size-discount{background:#46b783;color:#fff;}</style>'),i},i.updateContent=function(){return i.checkSizesChecks=0,i.checkSizesByCircle=setInterval(i.checkSizes,400),i.checkSizes(),i},i.checkSizes=function(){var e=c(".npps__size");return e.length?(e.each(function(){c(this).append('<div class="npps__size-discount"></div>')}),i.refreshDiscounts(),c(document).on("click","#rc_container > .rc_block > .rc_label",function(){setTimeout(function(){i.refreshDiscounts()},50)}),clearInterval(i.checkSizesByCircle)):24<i.checkSizesChecks?(clearInterval(i.checkSizesByCircle),i.checkSizesChecks=0):i.checkSizesChecks++,i},i.refreshDiscounts=function(){if(console.log("refreshDiscounts"),c(".npps__1pack-size").length){var s=meta.product.variants[0].price/100,e=c(".npps__size"),o=c(".rc_block__type__autodeliver.rc_block__type--active").length;e.each(function(){var e=c(this),i=e.find(".npps__size-discount");if(e.hasClass("npps__4pack-size")){var t=meta.product.variants[1].price/100;o&&(t*=.9);var n=4*s-t;console.log("sizeDiscountPrice",n),i.text("$"+n.toFixed(2)+" discount")}else if(e.hasClass("npps__8pack-size")){var p=meta.product.variants[2].price/100;o&&(p*=.9);n=8*s-p;i.text("$"+n.toFixed(2)+" discount")}})}return i},i.init()}(jQuery);
/* /WCZ#010 */


 
 
/* WCZ - Imporve menu icon w/ #fff8e
!function(n){var t=function(){};t.init=function(){return/^\/[0-9]+\/checkouts\/.+/.test(window.location.pathname)||t.addCSS().updateContent(),t},t.addCSS=function(){return n("head").append('<style type="text/css">@media only screen and (max-width:767px){header .top-bar-menu .top-content li a.cart-link{font-size:0;margin-top:53px;position:absolute;right:42px;display:block;}header .top-bar-menu .top-content li a.cart-link i{display:block;font-size:24px;}header .top-bar-menu .top-content li a.cart-link .cart-item{background:#f00;color:#fff;position:absolute;right:-10px;top:-8px;font-size:11px;padding:2px 6px;line-height:1;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;}body[data-cart-total="0"] header .top-bar-menu .top-content li a.cart-link .cart-item{display:none !important;}header .top-bar-menu .top-content li a.cart-link .cart-total{background:#8a8679;}}@media only screen and (min-width:768px){}@media only screen and (min-width:768px) and (max-width:991px){.nhs__container{top:46px !important;right:227px !important;}body:not([data-cart-total="0"]) .main-menu .toggle-menu{color:#ffff8e;}.main-menu .toggle-menu{width:auto !important;}.main-menu .toggle-menu:before{content:"CHOOSE YOUR JERKY";font-size:14px;margin-right:15px;display:inline-block;position:relative;bottom:3px;}}@media only screen and (min-width:992px){.nhs__container{margin-left:10px !important;}.top-bar-menu > .container{position:relative;}body:not([data-cart-total="0"]) header .main-menu .content-menu > li:last-child > a{color:#ffff8e;}.has-mini-cart{position:absolute !important;top:73px !important;margin-left:349px !important;}body[data-cart-total="0"] .has-mini-cart{right:15px !important;}.content-menu{margin-right:90px;}body[data-cart-total="0"] .content-menu{margin-right:68px;}.top-bar-menu .top-content li a.cart-link{font-size:0;display:block;}.top-bar-menu .top-content li a.cart-link i.material-icons{font-size:23px;margin-right:0;background:red;width:42px;height:36px;line-height:37px;text-align:center;color:#fff !important;}body[data-cart-total="0"] .top-bar-menu .top-content li a.cart-link i.material-icons{background:none;}.top-bar-menu .top-content li a.cart-link .cart-item{position:absolute;right:-9px;top:-9px;background:#fff;color:#222121;font-size:11px;min-width:18px;line-height:1;padding:2px 6px;text-align:center;display:block;}body[data-cart-total="0"] header .top-bar-menu .top-content li a.cart-link .cart-item{display:none !important;}.top-bar-menu .top-content li a.cart-link .cart-total{display:none !important;}.mini-cart-container{top:80% !important;right:0 !important;}.mini-cart-container .header-cart:before{display:none !important;}}</style>'),t},t.updateContent=function(){return t.checkCartTotal(),setInterval(function(){t.checkCartTotal()},1e3),t},t.checkCartTotal=function(){var t=n("header .top-bar-menu .top-content li a.cart-link .cart-item").text();n("body").attr("data-cart-total",t)},t.init()}(jQuery);
/* /WCZ - Imporve menu icon */

/* WCZ - Imporve menu icon without #fff8e*/
!function(n){var t=function(){};t.init=function(){return/^\/[0-9]+\/checkouts\/.+/.test(window.location.pathname)||t.addCSS().updateContent(),t},t.addCSS=function(){return n("head").append('<style type="text/css">@media only screen and (max-width:767px){header .top-bar-menu .top-content li a.cart-link{font-size:0;margin-top:53px;position:absolute;right:42px;display:block;}header .top-bar-menu .top-content li a.cart-link i{display:block;font-size:24px;}header .top-bar-menu .top-content li a.cart-link .cart-item{background:#f00;color:#fff;position:absolute;right:-10px;top:-8px;font-size:11px;padding:2px 6px;line-height:1;-webkit-border-radius:2px;-moz-border-radius:2px;border-radius:2px;}body[data-cart-total="0"] header .top-bar-menu .top-content li a.cart-link .cart-item{display:none !important;}header .top-bar-menu .top-content li a.cart-link .cart-total{background:#8a8679;}}@media only screen and (min-width:768px){}@media only screen and (min-width:768px) and (max-width:991px){.nhs__container{top:46px !important;right:227px !important;}body:not([data-cart-total="0"]) .main-menu .toggle-menu{color:#fff;}.main-menu .toggle-menu{width:auto !important;}.main-menu .toggle-menu:before{content:"CHOOSE YOUR JERKY";font-size:14px;margin-right:15px;display:inline-block;position:relative;bottom:3px;}}@media only screen and (min-width:992px){.nhs__container{margin-left:10px !important;}.top-bar-menu > .container{position:relative;}body:not([data-cart-total="0"]) header .main-menu .content-menu > li:last-child > a{color:#fff;}.has-mini-cart{position:absolute !important;top:73px !important;margin-left:349px !important;}body[data-cart-total="0"] .has-mini-cart{right:15px !important;}.content-menu{margin-right:90px;}body[data-cart-total="0"] .content-menu{margin-right:68px;}.top-bar-menu .top-content li a.cart-link{font-size:0;display:block;}.top-bar-menu .top-content li a.cart-link i.material-icons{font-size:23px;margin-right:0;background:red;width:42px;height:36px;line-height:37px;text-align:center;color:#fff !important;}body[data-cart-total="0"] .top-bar-menu .top-content li a.cart-link i.material-icons{background:none;}.top-bar-menu .top-content li a.cart-link .cart-item{position:absolute;right:-9px;top:-9px;background:#fff;color:#222121;font-size:11px;min-width:18px;line-height:1;padding:2px 6px;text-align:center;display:block;}body[data-cart-total="0"] header .top-bar-menu .top-content li a.cart-link .cart-item{display:none !important;}.top-bar-menu .top-content li a.cart-link .cart-total{display:none !important;}.mini-cart-container{top:80% !important;right:0 !important;}.mini-cart-container .header-cart:before{display:none !important;}}</style>'),t},t.updateContent=function(){return t.checkCartTotal(),setInterval(function(){t.checkCartTotal()},1e3),t},t.checkCartTotal=function(){var t=n("header .top-bar-menu .top-content li a.cart-link .cart-item").text();n("body").attr("data-cart-total",t)},t.init()}(jQuery);
/* /WCZ - Imporve menu icon */



/* WCZ#010B */
!function(r){var n=function(){};n.init=function(){return window.location.pathname.match(/\/products\/.+/)&&r('select.single-option-variant > option:contains("SINGLE PACK")').length&&r('select.single-option-variant > option:contains("4-PACK")').length&&r('select.single-option-variant > option:contains("8-PACK")').length&&r("body.template-product").length&&n.addCSS().updateContent(),n},n.addCSS=function(){return r("head").append('<style type="text/css">.npps__size-discount{display:none !important;}.npps__size-saving{height:20px;display:block;font-size:12px;text-align:center;position:relative;text-transform:uppercase;padding:5px 4px 3px;margin:6px -4px -11px;color:#40b881;-moz-border-radius:0 0 3px 3px; -webkit-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;line-height:1;}.npps__size:not(.npps__size-active) .npps__size-saving{background:#fff;background-image:-moz-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:-webkit-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:linear-gradient(to bottom,#fcfcfc 0%,#fff 100%);display:table;margin-right:auto;margin-left:auto;}.npps__1pack-size .npps__size-saving{opacity:0 !important;}.npps__size-active:before{border-color:#40b881 !important;}.npps__size-active .npps__size-saving{background:#46b783;color:#fff;}</style>'),n},n.updateContent=function(){return n.checkSizesChecks=0,n.checkSizesByCircle=setInterval(n.checkSizes,400),n.checkSizes(),n},n.checkSizes=function(){var e=r(".npps__size");return e.length?(e.each(function(){r(this).append('<div class="npps__size-saving"></div>')}),n.refreshDiscounts(),r(document).on("click","#rc_container > .rc_block > .rc_label",function(){setTimeout(function(){n.refreshDiscounts()},50)}),clearInterval(n.checkSizesByCircle)):24<n.checkSizesChecks?(clearInterval(n.checkSizesByCircle),n.checkSizesChecks=0):n.checkSizesChecks++,n},n.refreshDiscounts=function(){if(r(".npps__1pack-size").length){var c=meta.product.variants[0].price/100,e=r(".npps__size"),a=r(".rc_block__type__autodeliver.rc_block__type--active").length;e.each(function(){var e=r(this),n=e.find(".npps__size-saving");if(e.hasClass("npps__4pack-size")){var i=meta.product.variants[1].price/100;a&&(i*=.9);var t=(4*c-i)/i*100;n.text(parseInt(t)+"% discount")}else if(e.hasClass("npps__8pack-size")){var s=meta.product.variants[2].price/100;a&&(s*=.9);t=(8*c-s)/s*100;n.text(parseInt(t)+"% discount")}})}return n},n.init()}(jQuery);
/* /WCZ#010B */

/* WCZ#010 */
!function(c){var i=function(){};i.init=function(){return window.location.pathname.match(/\/products\/.+/)&&c('select.single-option-variant > option:contains("SINGLE PACK")').length&&c('select.single-option-variant > option:contains("2-PACK")').length&&c('select.single-option-variant > option:contains("4-PACK")').length&&c("body.template-product").length&&i.addCSS().updateContent(),i},i.addCSS=function(){return c("head").append('<style type="text/css">.npps__container{margin-top:-20px;position:relative;background:#fff;}.npps__sizes-list{margin-bottom:29px !important;}.npps__size{padding:5px 3px 6px !important;border-color:rgb(158,158,158) !important;}.npps__size-active:before{top:-7px !important;bottom:-7px !important;}.npps__size-icon{margin-bottom:3px !important;}.npps__size:not(.npps__size-active) .npps__size-icon{opacity:.5;}.npps__1pack-size .npps__size-icon{background-size:12px !important;}.npps__2pack-size .npps__size-icon{background-size:18px !important;}.npps__4pack-size .npps__size-icon{background-size:24px !important;}.npps__size-title{color:#888 !important;}.npps__size-discount{height:20px;display:block;font-size:12px;text-align:center;position:relative;text-transform:uppercase;padding:5px 4px 3px;margin:6px -4px -11px;color:#40b881;-moz-border-radius:0 0 3px 3px; -webkit-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;line-height:1;}.npps__size:not(.npps__size-active) .npps__size-discount{background:#fff;background-image:-moz-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:-webkit-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:linear-gradient(to bottom,#fcfcfc 0%,#fff 100%);display:table;margin-right:auto;margin-left:auto;}.npps__1pack-size .npps__size-discount{opacity:0 !important;}.npps__size-active:before{border-color:#40b881 !important;}.npps__size-active .npps__size-discount{background:#46b783;color:#fff;}</style>'),i},i.updateContent=function(){return i.checkSizesChecks=0,i.checkSizesByCircle=setInterval(i.checkSizes,400),i.checkSizes(),i},i.checkSizes=function(){var e=c(".npps__size");return e.length?(e.each(function(){c(this).append('<div class="npps__size-discount"></div>')}),i.refreshDiscounts(),c(document).on("click","#rc_container > .rc_block > .rc_label",function(){setTimeout(function(){i.refreshDiscounts()},50)}),clearInterval(i.checkSizesByCircle)):24<i.checkSizesChecks?(clearInterval(i.checkSizesByCircle),i.checkSizesChecks=0):i.checkSizesChecks++,i},i.refreshDiscounts=function(){if(console.log("refreshDiscounts"),c(".npps__1pack-size").length){var s=meta.product.variants[0].price/100,e=c(".npps__size"),o=c(".rc_block__type__autodeliver.rc_block__type--active").length;e.each(function(){var e=c(this),i=e.find(".npps__size-discount");if(e.hasClass("npps__2pack-size")){var t=meta.product.variants[1].price/100;o&&(t*=.9);var n=2*s-t;console.log("sizeDiscountPrice",n),i.text("$"+n.toFixed(2)+" discount")}else if(e.hasClass("npps__4pack-size")){var p=meta.product.variants[2].price/100;o&&(p*=.9);n=4*s-p;i.text("$"+n.toFixed(2)+" discount")}})}return i},i.init()}(jQuery);
/* /WCZ#010 */

/* WCZ#010B */
!function(r){var n=function(){};n.init=function(){return window.location.pathname.match(/\/products\/.+/)&&r('select.single-option-variant > option:contains("SINGLE PACK")').length&&r('select.single-option-variant > option:contains("2-PACK")').length&&r('select.single-option-variant > option:contains("4-PACK")').length&&r("body.template-product").length&&n.addCSS().updateContent(),n},n.addCSS=function(){return r("head").append('<style type="text/css">.npps__size-discount{display:none !important;}.npps__size-saving{height:20px;display:block;font-size:12px;text-align:center;position:relative;text-transform:uppercase;padding:5px 4px 3px;margin:6px -4px -11px;color:#40b881;-moz-border-radius:0 0 3px 3px; -webkit-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;line-height:1;}.npps__size:not(.npps__size-active) .npps__size-saving{background:#fff;background-image:-moz-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:-webkit-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:linear-gradient(to bottom,#fcfcfc 0%,#fff 100%);display:table;margin-right:auto;margin-left:auto;}.npps__1pack-size .npps__size-saving{opacity:0 !important;}.npps__size-active:before{border-color:#40b881 !important;}.npps__size-active .npps__size-saving{background:#46b783;color:#fff;}</style>'),n},n.updateContent=function(){return n.checkSizesChecks=0,n.checkSizesByCircle=setInterval(n.checkSizes,400),n.checkSizes(),n},n.checkSizes=function(){var e=r(".npps__size");return e.length?(e.each(function(){r(this).append('<div class="npps__size-saving"></div>')}),n.refreshDiscounts(),r(document).on("click","#rc_container > .rc_block > .rc_label",function(){setTimeout(function(){n.refreshDiscounts()},50)}),clearInterval(n.checkSizesByCircle)):24<n.checkSizesChecks?(clearInterval(n.checkSizesByCircle),n.checkSizesChecks=0):n.checkSizesChecks++,n},n.refreshDiscounts=function(){if(r(".npps__1pack-size").length){var c=meta.product.variants[0].price/100,e=r(".npps__size"),a=r(".rc_block__type__autodeliver.rc_block__type--active").length;e.each(function(){var e=r(this),n=e.find(".npps__size-saving");if(e.hasClass("npps__2pack-size")){var i=meta.product.variants[1].price/100;a&&(i*=.9);var t=(2*c-i)/i*100;n.text(parseInt(t)+"% discount")}else if(e.hasClass("npps__4pack-size")){var s=meta.product.variants[2].price/100;a&&(s*=.9);t=(4*c-s)/s*100;n.text(parseInt(t)+"% discount")}})}return n},n.init()}(jQuery);
/* /WCZ#010B */

/* WCZ#013 */
!function(t){/^\/cart$/.test(window.location.pathname)&&t("head").append('<style type="text/css">.cart-collaterals > .inner > div:nth-child(2){display:none !important;}</style>')}(jQuery);
/* /WCZ#013 */


/* WCZ#010 6/18/36 Sticks */
!function(r){var n=function(){};n.init=function(){return window.location.pathname.match(/\/products\/.+/)&&r('select.single-option-variant > option:contains("6-STICKS")').length&&r('select.single-option-variant > option:contains("18-STICKS")').length&&r('select.single-option-variant > option:contains("36-STICKS")').length&&r("body.template-product").length&&n.addCSS().updateContent(),n},n.addCSS=function(){return r("head").append('<style type="text/css">.npps__size-discount{display:none !important;}.npps__size-saving{height:20px;display:block;font-size:12px;text-align:center;position:relative;text-transform:uppercase;padding:5px 4px 3px;margin:6px -4px -11px;color:#40b881;-moz-border-radius:0 0 3px 3px; -webkit-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;line-height:1;}.npps__size:not(.npps__size-active) .npps__size-saving{background:#fff;background-image:-moz-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:-webkit-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:linear-gradient(to bottom,#fcfcfc 0%,#fff 100%);display:table;margin-right:auto;margin-left:auto;}.npps__6stick-size .npps__size-saving{opacity:0 !important;}.npps__size-active:before{border-color:#40b881 !important;}.npps__size-active .npps__size-saving{background:#46b783;color:#fff;}</style>'),n},n.updateContent=function(){return n.checkSizesChecks=0,n.checkSizesByCircle=setInterval(n.checkSizes,400),n.checkSizes(),n},n.checkSizes=function(){var e=r(".npps__size");return e.length?(e.each(function(){r(this).append('<div class="npps__size-saving"></div>')}),n.refreshDiscounts(),r(document).on("click","#rc_container > .rc_block > .rc_label",function(){setTimeout(function(){n.refreshDiscounts()},50)}),clearInterval(n.checkSizesByCircle)):24<n.checkSizesChecks?(clearInterval(n.checkSizesByCircle),n.checkSizesChecks=0):n.checkSizesChecks++,n},n.refreshDiscounts=function(){if(r(".npps__6stick-size").length){var c=meta.product.variants[0].price/6,e=r(".npps__size"),a=r(".rc_block__type__autodeliver.rc_block__type--active").length;e.each(function(){var e=r(this),n=e.find(".npps__size-saving");if(e.hasClass("npps__18pack-size")){var i=meta.product.variants[1].price/18;a&&(i*=1);var t=(c-i)/c*100;n.text(parseInt(t)+"% discount")}else if(e.hasClass("npps__36pack-size")){var s=meta.product.variants[2].price/36;a&&(s*=1);t=(c-s)/c*100;n.text(parseInt(t)+"% discount")}})}return n},n.init()}(jQuery);
/* /WCZ#010 6/18/36 Sticks */


/* WCZ#010 5/15/30 Sticks */
!function(r){var n=function(){};n.init=function(){return window.location.pathname.match(/\/products\/.+/)&&r('select.single-option-variant > option:contains("5-STICKS")').length&&r('select.single-option-variant > option:contains("15-STICKS")').length&&r('select.single-option-variant > option:contains("30-STICKS")').length&&r("body.template-product").length&&n.addCSS().updateContent(),n},n.addCSS=function(){return r("head").append('<style type="text/css">.npps__size-discount{display:none !important;}.npps__size-saving{height:20px;display:block;font-size:12px;text-align:center;position:relative;text-transform:uppercase;padding:5px 4px 3px;margin:6px -4px -11px;color:#40b881;-moz-border-radius:0 0 3px 3px; -webkit-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;line-height:1;}.npps__size:not(.npps__size-active) .npps__size-saving{background:#fff;background-image:-moz-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:-webkit-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:linear-gradient(to bottom,#fcfcfc 0%,#fff 100%);display:table;margin-right:auto;margin-left:auto;}.npps__5stick-size .npps__size-saving{opacity:0 !important;}.npps__size-active:before{border-color:#40b881 !important;}.npps__size-active .npps__size-saving{background:#46b783;color:#fff;}</style>'),n},n.updateContent=function(){return n.checkSizesChecks=0,n.checkSizesByCircle=setInterval(n.checkSizes,400),n.checkSizes(),n},n.checkSizes=function(){var e=r(".npps__size");return e.length?(e.each(function(){r(this).append('<div class="npps__size-saving"></div>')}),n.refreshDiscounts(),r(document).on("click","#rc_container > .rc_block > .rc_label",function(){setTimeout(function(){n.refreshDiscounts()},50)}),clearInterval(n.checkSizesByCircle)):24<n.checkSizesChecks?(clearInterval(n.checkSizesByCircle),n.checkSizesChecks=0):n.checkSizesChecks++,n},n.refreshDiscounts=function(){if(r(".npps__5stick-size").length){var c=meta.product.variants[0].price/5,e=r(".npps__size"),a=r(".rc_block__type__autodeliver.rc_block__type--active").length;e.each(function(){var e=r(this),n=e.find(".npps__size-saving");if(e.hasClass("npps__15pack-size")){var i=meta.product.variants[1].price/15;a&&(i*=1);var t=(c-i)/c*100;n.text(parseInt(t)+"% discount")}else if(e.hasClass("npps__30pack-size")){var s=meta.product.variants[2].price/30;a&&(s*=1);t=(c-s)/c*100;n.text(parseInt(t)+"% discount")}})}return n},n.init()}(jQuery);
/* /WCZ#010 5/15/30 Sticks */

/* WCZ#014A 2/4/8 Drops */
!function(c){var i=function(){};i.init=function(){return window.location.pathname.match(/\/products\/.+/)&&c('select.single-option-variant > option:contains("2-PACK")').length&&c('select.single-option-variant > option:contains("4-PACK")').length&&c('select.single-option-variant > option:contains("8-PACK")').length&&c("body.template-product").length&&i.addCSS().updateContent(),i},i.addCSS=function(){return c("head").append('<style type="text/css">.npps__container{margin-top:-20px;position:relative;background:#fff;}.npps__sizes-list{margin-bottom:29px !important;}.npps__size{padding:5px 3px 6px !important;border-color:rgb(158,158,158) !important;}.npps__size-active:before{top:-7px !important;bottom:-7px !important;}.npps__size-icon{margin-bottom:3px !important;}.npps__size:not(.npps__size-active) .npps__size-icon{opacity:.5;}.npps__2pack-size .npps__size-icon{background-size:12px !important;}.npps__4pack-size .npps__size-icon{background-size:18px !important;}.npps__8pack-size .npps__size-icon{background-size:24px !important;}.npps__size-title{color:#888 !important;}.npps__size-discount{height:20px;display:block;font-size:12px;text-align:center;position:relative;text-transform:uppercase;padding:5px 4px 3px;margin:6px -4px -11px;color:#40b881;-moz-border-radius:0 0 3px 3px; -webkit-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;line-height:1;}.npps__size:not(.npps__size-active) .npps__size-discount{background:#fff;background-image:-moz-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:-webkit-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:linear-gradient(to bottom,#fcfcfc 0%,#fff 100%);display:table;margin-right:auto;margin-left:auto;}.npps__2pack-size .npps__size-discount{opacity:0 !important;}.npps__size-active:before{border-color:#40b881 !important;}.npps__size-active .npps__size-discount{background:#46b783;color:#fff;}</style>'),i},i.updateContent=function(){return i.checkSizesChecks=0,i.checkSizesByCircle=setInterval(i.checkSizes,400),i.checkSizes(),i},i.checkSizes=function(){var e=c(".npps__size");return e.length?(e.each(function(){c(this).append('<div class="npps__size-discount"></div>')}),i.refreshDiscounts(),c(document).on("click","#rc_container > .rc_block > .rc_label",function(){setTimeout(function(){i.refreshDiscounts()},50)}),clearInterval(i.checkSizesByCircle)):24<i.checkSizesChecks?(clearInterval(i.checkSizesByCircle),i.checkSizesChecks=0):i.checkSizesChecks++,i},i.refreshDiscounts=function(){if(console.log("refreshDiscounts"),c(".npps__2pack-size").length){var s=meta.product.variants[0].price/100,e=c(".npps__size"),o=c(".rc_block__type__autodeliver.rc_block__type--active").length;e.each(function(){var e=c(this),i=e.find(".npps__size-discount");if(e.hasClass("npps__4pack-size")){var t=meta.product.variants[1].price/100;o&&(t*=.9);var n=4*s-t;console.log("sizeDiscountPrice",n),i.text("$"+n.toFixed(2)+" discount")}else if(e.hasClass("npps__8pack-size")){var p=meta.product.variants[2].price/100;o&&(p*=.9);n=8*s-p;i.text("$"+n.toFixed(2)+" discount")}})}return i},i.init()}(jQuery);
/* WCZ#014A 2/4/8 Drops */



/* WCZ#010C */
!function(r){var n=function(){};n.init=function(){return window.location.pathname.match(/\/products\/.+/)&&r('select.single-option-variant > option:contains("4-STICKS")').length&&r('select.single-option-variant > option:contains("12-STICKS")').length&&r('select.single-option-variant > option:contains("24-STICKS")').length&&r("body.template-product").length&&n.addCSS().updateContent(),n},n.addCSS=function(){return r("head").append('<style type="text/css">.npps__size-discount{display:none !important;}.npps__size-saving{height:20px;display:block;font-size:12px;text-align:center;position:relative;text-transform:uppercase;padding:5px 4px 3px;margin:6px -4px -11px;color:#40b881;-moz-border-radius:0 0 3px 3px; -webkit-border-radius:0 0 3px 3px;border-radius:0 0 3px 3px;line-height:1;}.npps__size:not(.npps__size-active) .npps__size-saving{background:#fff;background-image:-moz-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:-webkit-linear-gradient(top,#fcfcfc 0%,#fff 100%);background-image:linear-gradient(to bottom,#fcfcfc 0%,#fff 100%);display:table;margin-right:auto;margin-left:auto;}.npps__4stick-size .npps__size-saving{opacity:0 !important;}.npps__size-active:before{border-color:#40b881 !important;}.npps__size-active .npps__size-saving{background:#46b783;color:#fff;}</style>'),n},n.updateContent=function(){return n.checkSizesChecks=0,n.checkSizesByCircle=setInterval(n.checkSizes,400),n.checkSizes(),n},n.checkSizes=function(){var e=r(".npps__size");return e.length?(e.each(function(){r(this).append('<div class="npps__size-saving"></div>')}),n.refreshDiscounts(),r(document).on("click","#rc_container > .rc_block > .rc_label",function(){setTimeout(function(){n.refreshDiscounts()},50)}),clearInterval(n.checkSizesByCircle)):24<n.checkSizesChecks?(clearInterval(n.checkSizesByCircle),n.checkSizesChecks=0):n.checkSizesChecks++,n},n.refreshDiscounts=function(){if(r(".npps__4stick-size").length){var c=meta.product.variants[0].price/4,e=r(".npps__size"),a=r(".rc_block__type__autodeliver.rc_block__type--active").length;e.each(function(){var e=r(this),n=e.find(".npps__size-saving");if(e.hasClass("npps__12pack-size")){var i=meta.product.variants[1].price/12;a&&(i*=1);var t=(c-i)/c*100;n.text(parseInt(t)+"% discount")}else if(e.hasClass("npps__24pack-size")){var s=meta.product.variants[2].price/24;a&&(s*=1);t=(c-s)/c*100;n.text(parseInt(t)+"% discount")}})}return n},n.init()}(jQuery);
/* /WCZ#010C */




// CD CODE
$(document).on('click', '.header .menu-responsive .left-arrows-menu', function(e){
  e.preventDefault();
  var menu = $(this).parent('.level-top').attr('data-level');
  $('.links').removeClass('active');
  $('.second_level').removeClass('active');
  $('#'+menu ).addClass('active');
});


$(document).ready(function() {
  $('.header .main-menu .right.menu .cart-link').css('visibility', 'visible');
});